import { IPaymentMethod } from 'state/payment/types';
import { isApplePay, isGooglePay } from 'utils/payment/native-payment';

import { IGetSortedValidPaymentMethods } from '../types';

const isAppleOrGooglePay = (accountIdentifier: string | null) =>
  isApplePay(accountIdentifier) || isGooglePay(accountIdentifier);
const isVaultedCC = (paymentMethod: IPaymentMethod) =>
  paymentMethod.credit && !!paymentMethod.chaseProfileId;
const isPrepaidPaymentMethod = (paymentMethod: IPaymentMethod) => !!paymentMethod.prepaid;

export const isValidScanAndPayPaymentMethod = (paymentMethod: IPaymentMethod) => {
  return (
    !isAppleOrGooglePay(paymentMethod.accountIdentifier) &&
    (isVaultedCC(paymentMethod) || isPrepaidPaymentMethod(paymentMethod))
  );
};

export const hasValidScanAndPayPaymentMethodOption = (paymentMethods: IPaymentMethod[]) =>
  paymentMethods.some(isValidScanAndPayPaymentMethod);

export const getSortedValidPaymentMethods = ({
  paymentMethods,
  selectedPaymentMethodId,
}: IGetSortedValidPaymentMethods) =>
  paymentMethods.reduce(
    (acc, option) => {
      if (option.accountIdentifier === selectedPaymentMethodId) {
        acc.selectedPaymentMethod = option;
      } else if (isValidScanAndPayPaymentMethod(option)) {
        acc.nonSelectedPaymentMethods.push(option);
      }
      return acc;
    },
    {
      selectedPaymentMethod: {} as IPaymentMethod,
      nonSelectedPaymentMethods: [] as IPaymentMethod[],
    }
  );

export const getDefaultPaymentMethodId = (paymentMethods: IPaymentMethod[]) => {
  const ccPaymentMethod = paymentMethods.find(
    paymentMethod =>
      isValidScanAndPayPaymentMethod(paymentMethod) && !isPrepaidPaymentMethod(paymentMethod)
  );
  const prepaidPaymentMethod = paymentMethods.find(
    paymentMethod =>
      isValidScanAndPayPaymentMethod(paymentMethod) && isPrepaidPaymentMethod(paymentMethod)
  );
  if (ccPaymentMethod) {
    return ccPaymentMethod.accountIdentifier;
  }
  if (prepaidPaymentMethod) {
    return prepaidPaymentMethod.accountIdentifier;
  }
  return '';
};
